var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C917B7B-7E91-4C4C-A85B-712CA0A3B8EC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-321.000000, -460.000000)",
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.25,461 L324.514706,461 C323.126515,461.001492 322.001501,462.120011 322,463.500187 L322,470.722949 C322.001501,472.103125 323.126515,473.221644 324.514706,473.223136 L325.291411,473.223136 L324.799711,475.667709 C324.778564,475.772833 324.820176,475.880534 324.906401,475.944694 C324.992626,476.008853 325.108319,476.017941 325.203685,475.968024 L330.451387,473.223136 L336.25,473.223136 C337.638191,473.221644 338.763205,472.103125 338.764706,470.722949 L338.764706,463.500187 C338.763205,462.120011 337.638191,461.001492 336.25,461 Z M338.205882,470.722949 C338.204654,471.796434 337.329719,472.666318 336.25,472.667539 L330.382353,472.667539 C330.336921,472.667539 330.292308,472.678526 330.252197,472.699551 L325.462769,475.205842 L325.906171,473.000951 C325.922952,472.919158 325.901942,472.834245 325.84887,472.769679 C325.795798,472.704977 325.716258,472.667539 325.632353,472.667539 L324.514706,472.667539 C323.434987,472.666318 322.560051,471.796434 322.558824,470.722949 L322.558824,463.500187 C322.560051,462.426702 323.434987,461.556818 324.514706,461.555597 L336.25,461.555597 C337.329719,461.556818 338.204654,462.426702 338.205882,463.500187 L338.205882,470.722949 Z",
    id: "opmerking"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.0f32385a207971ef1e8d9f352e7170f8.svg";
export { ForwardRef as ReactComponent };